import React, { useEffect } from 'react'
import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import { useContextParameters } from '../../../../../services/api/hooks/useContextParameters'

const ExchangeRatePage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { companyId } = useContextParameters()

  const { contextCompanyId } = (location.state ?? {}) as { contextCompanyId?: string }

  useEffect(() => {
    if (location.pathname.endsWith('edit') && contextCompanyId != null && contextCompanyId !== companyId) {
      navigate(-1)
    }
  }, [companyId, contextCompanyId, location.pathname, navigate])

  return (
    <div>
      <Outlet />
    </div>
  )
}

export default ExchangeRatePage
